import React, { Component } from "react";
import { Field } from "formik";
import { isFieldValidClass } from "~/js/utils";

class Input extends Component {
    state = {
        isFocused: false,
        hasChanged: false,
        currentValue: "",
    };

    componentDidMount() {
        this.setCurrentValue();
    }

    componentDidUpdate() {
        this.setCurrentValue();
    }

    setCurrentValue = () => {
        const { currentValue } = this.state;
        const { value, form, name } = this.props;

        if (typeof value !== "undefined") {
            if (value !== currentValue) {
                this.setState({ currentValue: value });
            }
        }

        // For cases when the form value updates
        if (form) {
            if (form.values[name] !== currentValue) {
                this.setState({ currentValue: form.values[name] });
            }
        }
    };

    handleChange = (e) => {
        this.update(e);
        this.setState({ hasChanged: true });
    };

    handleInput = (e) => {
        this.update(e);
    };

    update = (e) => {
        let value = e.target.value;
        const { onChange, form, name, valueFilter, suffix } = this.props;

        if (valueFilter) value = valueFilter(value);
        if (onChange) onChange(e);
        if (form) form.setFieldValue(name, value);

        // if (suffix) value += `${suffix}`;

        // console.log('currentValue', suffix, value)
        this.setState({ currentValue: value });
    };

    handleFocus = () => this.setState({ isFocused: true });

    handleBlur = (e) => {
        const { form } = this.props;

        if (form) form.handleBlur(e);

        this.setState({ isFocused: false });
    };

    render() {
        const {
            label,
            type,
            modifiers,
            form,
            name,
            valueFilter,
            suffix,
            onChange,
            value,
            curvedRadius,
            darkBackground,
            children,
            ...rest
        } = this.props;
        const { isFocused, hasChanged, currentValue } = this.state;

        let className = "input";
        if (modifiers) modifiers.forEach((m) => (className += ` input--${m}`));
        if (form) className += ` ${isFieldValidClass(name, form)}`;
        if (isFocused) className += ` is-focused`;
        if (hasChanged) className += ` has-changed`;

        // If using Formik, use Field component (has all the bindings)
        const FieldTag = form ? Field : "input";

        // console.log(this.props);

        return (
            <div className={className}>
                <div   className={`input__field ${curvedRadius ? "curvedRadius" : ""} ${darkBackground ? "input__field-dark" : ""} `}>
                    {modifiers.findIndex((m) => m === "search-left") !== -1 ? (
                        <div className="input__search">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6.22273" cy="6.22224" r="5.47273" stroke="rgb(159, 159, 159)"
                                        stroke-width="1.5"/>
                                <path d="M11.667 11.667L14.0005 14.0005" stroke="rgb(159, 159, 159)" stroke-width="1.5"
                                      stroke-linecap="round"/>
                            </svg>

                        </div>
                    ) : null}
                    <FieldTag
                        type={type || "text"}
                        name={name}
                        value={currentValue || ''}
                        onFocus={this.handleFocus}
                        onChange={this.handleChange}
                        onInput={this.handleInput}
                        onBlur={this.handleBlur}
                        {...rest}
                    />
                    {children}
                    {modifiers.findIndex((m) => m === "search") !== -1 ? (
                        <div className="input__search">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="8.62695"
                                    cy="8.06641"
                                    r="7"
                                    stroke="white"
                                    strokeWidth="2"
                                />
                                <path
                                    d="M15.627 15.0664L18.627 18.0664"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export { Input };
